import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TableHeader = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <div>
        <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }} color={theme.colors.text.subtle}>
          {t('Método de devolución')}
        </Text>
      </div>
      <Styles.TotalsContainer>
        <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }} color={theme.colors.text.subtle}>
          {t('Solicitudes')}
        </Text>
        <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }} color={theme.colors.text.subtle}>
          %
        </Text>
      </Styles.TotalsContainer>
    </Styles.Container>
  )
}

export default TableHeader
